import axios, { AxiosInstance, AxiosError, AxiosResponse, AxiosRequestConfig } from 'axios';

/**
 * Helper that creates and configures an instance of Axios to be used throughout
 * the client application. This will also handle forbidden (403) errors via interceptors.
 */
const AxiosHelper: AxiosInstance = axios.create({
	withCredentials: false,
});

export default AxiosHelper;

export const addAccessDeniedInterceptor = history => {
	// this allows us to act when any request going through axios succeeds or fails.
	AxiosHelper.interceptors.response.use(
		(response: AxiosResponse) => {
			return response;
		},
		(error: AxiosError) => {
			const config: AxiosRequestConfig = error.config;

			if (config && error.response && error.response.status === 403) {
				history.replace('/access-denied');
			}

			if (error.response && error.response.status === 401) {
				window.location.replace('/access-denied');
			}

			return Promise.reject(error);
		}
	);
};
